import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children }) => {
    const { user } = useAuth();
    if (user === null) {
        return (
            <div data-testid="admin-loading" className="flex min-h-screen items-center justify-center bg-night">
                <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-ivory/40">Checking access…</span>
            </div>
        );
    }
    if (!user) return <Navigate to="/admin/login" replace />;
    return children;
};
